import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterLink} from '@angular/router';
import {DxDataGridModule, DxFormModule, DxTemplateModule} from 'devextreme-angular';
import {DxDataGridTypes} from 'devextreme-angular/ui/data-grid';
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {PurchaseOrderGridViewDto, PurchaseOrderStatus} from "@services";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {CapitalCasePipe} from "../../../pipes/capital-case.pipe";
import EnumUtils from "../../../shared/enum-utils";

@Component({
  selector: 'app-purchase-orders',
  standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        FilterPanelComponent,
        RouterLink,
        CapitalCasePipe
    ],
  templateUrl: './purchase-orders.component.html',
  styles: [
      `.grid {
          height: calc(100vh - 100px);
      }`
  ]
})
export class PurchaseOrdersComponent extends GridPageComponent<PurchaseOrderGridViewDto> {
    private router = inject(Router);

    constructor() {
        super();
        this.init(PurchaseOrderGridViewDto);
    }

    dataSource = this.dataSources.purchaseOrders();
    statusOptions = EnumUtils.getEnumOptions(PurchaseOrderStatus);

    protected override exportName: string = "PurchaseOrders";

    protected override filterConfig: FilterConfig[] = [
        {field: 'purchasingDocument', op: 'contains'},
        {field: 'supplierNumber', op: 'contains'},
        {field: 'vendorSupplyingPlant', op: 'contains'},
        {field: 'supplyingPlant', op: 'contains'},
        {field: 'documentDate', op: '>='},
        {field: 'receivingPlant', op: 'contains'},
        {field: 'companyCode', op: 'contains'},
        {field: 'purchasingGroup', op: 'contains'},
        {field: 'purchasingDocType', op: 'contains'},
        {field: 'purchaseOrderNumber', op: 'contains'},
        {field: 'asnReferenceNumber', op: 'contains'},
        {field: 'shipFromName', op: 'contains'},
        {field: 'shippingPointReceivingPt', op: 'contains'},
        {field: 'carrierCode', op: 'contains'},
        {field: 'carrierName', op: 'contains'},
        {field: 'scac', op: 'contains'},
        {field: 'transportStatus', op: 'contains'},
        {field: 'ourReference', op: 'contains'},
        {field: 'vehicleType', op: 'contains'},
        {field: 'shipToName', op: 'contains'},
        {field: 'deliveryDate', op: '>='}
    ];

    override async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        const {data} = e;
        await this.router.navigate([`/inbound/purchase-orders/details/${data.purchasingDocument}`]);
    }

    protected getStatusBadgeClass(status: PurchaseOrderStatus): string {
        return EnumUtils.getPurchaseStatusBadgeClass(status);
    }
}
